import type { OrderAttributesFieldValues } from "@jti/commerce-types/types";

import type { ConsentFieldConfig } from "./factories/consentFieldFactory";

export type ConsentAndPayFormFields = {
  orderAttributes: OrderAttributesFieldValues;
  consent: boolean;
};

export type ConsentAndPayFormFieldsNames = keyof ConsentAndPayFormFields;

export type ConsentAndPayFormFieldsDefaultValues = ConsentAndPayFormFields;

export type ConsentAndPayFormFieldsConfig = {
  consent: ConsentFieldConfig;
};
